module.exports = __webpack_public_path__ + "img/dd-logo-lincoln.de1f36a8.png";